<template>
  <scout-form
    label="行動ターゲティング"
    has-child
  >
    <div class="boss-table-2-layout">
      <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact">
        職種で検索している会員を探す
      </div>
      <div
        :class="{ 'is-modified': !!occupation.length }"
        class="boss-table-2-item boss-table-2-item-body"
      >
        <div class="boss-layout boss-layout-vertical">
          <div>
            <div class="boss-layout boss-layout-start">
              <div>
                <select-modal-button
                  v-if="occupationsMaster.length > 0"
                  :master-data="occupationsMaster"
                  :selected-items="occupation.map(n => { return { id: n, experience: '' } })"
                  title="職種"
                  suffix="searching-occupations"
                  data-test="modal-occupations"
                  button-label="職種を選択する"
                  @update-modal-checked-ids="value => $emit('update:occupation', value.map(o => o.id))"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-table-2-layout">
      <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact">
        勤務地で検索している会員を探す
      </div>
      <div
        :class="{ 'is-modified': !!prefecture.length }"
        class="boss-table-2-item boss-table-2-item-body"
      >
        <div class="boss-layout boss-layout-vertical">
          <div>
            <div class="boss-layout boss-layout-start">
              <div>
                <select-modal-button
                  v-if="prefecturesMaster.length > 0"
                  :master-data="prefecturesMaster"
                  :selected-items="prefecture.map(n => { return { id: n, experience: '' } })"
                  title="都道府県"
                  button-label="勤務地を選択する"
                  suffix="searching-prefectures"
                  data-test="modal-prefectures"
                  @update-modal-checked-ids="value => $emit('update:prefecture', value.map(o => o.id))"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-table-2-layout">
      <div class="boss-table-2-item boss-table-2-item-head boss-table-2-item-head-compact">
        業種で検索している会員を探す
      </div>
      <div
        :class="{ 'is-modified': !!sector.length }"
        class="boss-table-2-item boss-table-2-item-body"
      >
        <div class="boss-layout boss-layout-vertical">
          <div>
            <div class="boss-layout boss-layout-start">
              <div>
                <select-modal-button
                  v-if="businessesMaster.length > 0"
                  :master-data="businessesMaster"
                  :selected-items="sector.map(n => { return { id: n, experience: '' } })"
                  title="業種"
                  suffix="searching-sectors"
                  button-label="業種を選択する"
                  data-test="modal-sectors"
                  @update-modal-checked-ids="value => $emit('update:sector', value.map(o => o.id))"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import SelectModalButton from '@/components/organisms/SelectModalButton'
import { mapGetters } from 'vuex'

export default {
  components: {
    ScoutForm,
    SelectModalButton
  },
  props: {
    occupation: {
      required: true,
      type: Array
    },
    prefecture: {
      required: true,
      type: Array
    },
    sector: {
      required: true,
      type: Array
    }
  },
  computed: {
    ...mapGetters([
      'occupationsMaster',
      'prefecturesMaster',
      'businessesMaster'
    ])
  }
}
</script>
